package com.patronat.top.core.domain.usecase.command.auth

import com.patronat.top.domain.usecase.Command


data class SendCodeToPhoneCommand(
    val phone: String
) : Command